<template>
  <div >
      <div v-show ="diplayMode == 'list'" style="margin-bottom: 70px" class="woList">
        <van-nav-bar 
        style="position:fixed;width:100%">
          <template #title>
            <span>我的任务</span>
          </template>
        </van-nav-bar>

        
        <van-row style="overflow-y: scroll;padding:45px 20px" :style="{ height:height}">
          <van-cell v-for="(subWo,index) in data" :key="subWo.woId" title="" style="margin:10px 0">
                <!-- 使用 right-icon 插槽来自定义右侧图标 -->
                <template #label>
                  <van-row >
                    <div class="wrapper">
                      <van-col span="24"><span class="detailTitle">单号:</span> <span class="detailContent">【{{subWo.woId}}】</span></van-col>
                      <van-col span="12"><span class="detailTitle">日期: </span> <span class="detailContent">{{subWo.date}}</span></van-col>
                      <van-col span="12"><span class="detailTitle">品号:</span> <span class="detailContent">{{subWo.productNo}}</span></van-col>
                      
                      <van-col span="12"><span class="detailTitle">单位:</span> <span class="detailContent">{{subWo.unit}}</span></van-col>
                      <van-col span="12"><span class="detailTitle">数量:</span> <span class="detailContent">{{subWo.count}}</span></van-col>  
                      <van-col span="24"><span class="detailTitle">规格:</span> <span class="detailContent">{{subWo.spec}}</span></van-col>
                      <van-col span="24"><span class="detailTitle">品名:</span> <span class="detailContent">{{subWo.productName}}</span></van-col>
                    </div>
                  </van-row>
                  <van-row>
                    <van-col span="24" style="height:20px" v-if="index == 0">
                      <span style="position:absolute;color:#1989fa;right:16px;" @click="startWoStatus(subWo)">开工</span>
                      <van-icon  style="position:absolute;margin-top:1px;margin-right:2px;right:42px;" name="more" size="16" color="#1989fa"/>
                    </van-col>
                  </van-row>
                </template>
            </van-cell>

            <van-empty description="暂无数据" v-if="data.length == 0"/>
        </van-row>
      </div>

     <DateSelectDialog
      ref="startDateSelectDialog"
      @confirm="(date) => (queryParams.startDate = date)"
    ></DateSelectDialog>

    <DateSelectDialog
      ref="endDateSelectDialog"
      @confirm="(date) => (queryParams.endDate = date)"
    ></DateSelectDialog>
  </div>
</template>

<script>
import { getUserWoAssTask ,startWo} from "../../../api/wo";
import { Toast, Dialog } from "vant";

import store from '../../../store/index'
import { Notify } from 'vant';
export default {
  components: {
    Dialog
  },
  computed: {
    height(){
        var offH = (this.activeNames.length >0)?40:60;
        var h = window.innerHeight - 220 + offH + 'px';
        return h;
    },
    startDateTimeFormatter() {
      return !this.queryParams.startDate || this.queryParams.startDate == ""
        ? ""
        : this.$dateTimeUtil.formate("YYYY年mm月dd日", this.queryParams.startDate);
    },
    endDateTimeFormatter() {
      return !this.queryParams.endDate || this.queryParams.endDate == ""
        ? ""
        : this.$dateTimeUtil.formate("YYYY年mm月dd日", this.queryParams.endDate);
    }
  },
  data() {
    return {
      title: "工单列表",
      queryParams: {
        startDate: "",
        endDate:"",
        woStatus:"未完工"
      },
      diplayMode:"list",
      activeNames:['1'],
      data:[],
      scanWoId:null,
      showDatePicker: false,
    };
  },
  mounted() {
    this.queryParams.endDate = new Date();

    this.loadTask();
  },
  methods: {
    viewDetail(subWo){
      this.diplayMode = 'detail';
      this.$nextTick(o=>{
        this.$refs.woDetail.open(subWo);
      })
    },
    startWoStatus(wo){
      Toast.loading({
          message: '数据提交...',
          forbidClick: true,
          duration: 0 
      });

      startWo(wo.woId).then(res=>{
        Toast.clear();
        if(res.code == 200) {
          Notify({ type: 'success', message: `工单${wo.woId}开工成功!`});

          this.loadTask();
        }
      })
    },
    loadTask() {
      var startDate = this.queryParams.startDate == ""?"":this.$dateTimeUtil.formate("YYYY/mm/dd", this.queryParams.startDate);
      var endDate = this.queryParams.endDate == ""?"":this.$dateTimeUtil.formate("YYYY/mm/dd", this.queryParams.endDate);

      Toast.loading({
          message: '数据加载中...',
          forbidClick: true,
          duration: 0 
      });

      getUserWoAssTask({
        userId:store.state.authorize.user.userNo
      }).then(res=>{
        Toast.clear();
        this.activeNames = [];
        if(res.code == 200) {
          this.data = res.data;
        }
        else{
          this.data = [];
          Dialog.alert({
            message: res.message,
          });
        }
      });
    },
    goToList() {
      this.diplayMode = 'list';
    }
  },
};
</script>

<style lang="less" scoped>
.van-radio-group {
  width: 100%;
}
</style>

<style lang="less" scoped>
 .detailTitle{
    display: inline-block;
    color:#434040 !important;
    font-size: 15px;
    margin-right: 2px;
    font-weight: 700;
    width:64px;
    text-align-last: justify;
    float:left;
  }
  .detailContent{
    display: inline-block;
    color:black;
    font-size: 14px;
    font-weight: 300;
    width:calc(100% - 80px);
    float:left;
  }

  .wrapper div { margin-top:4px;}
  .van-field{
    padding:5px 16px;
  }

  .van-radio--horizontal{
    margin-right:4px;
  }
</style>

<style>
  .van-collapse-item__content
  {
      padding:0;
  }

  .van-collapse-item__wrapper
  {
      margin-top:-12px !important;
    }

    .van-collapse-item__title{
      height:48px;
    }

    .woList .van-cell-group--inset{
  margin-left:0;
  margin-right:0;
  padding-top:5px;
 }

 .van-cell__title{
  font-size:14px;
  font-weight:700;
 }

 .van-radio__label{
  margin-left:4px;
 }

  </style>
  